export const UNKNOWN = 0;

export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const REQUEST_TIMEOUT = 408;
export const CONFLICT = 409;
export const TOO_MANY_REQUESTS = 429;

export const INTERNAL_SERVER_ERROR = 501;
export const BAD_GATEWAY = 502;
export const SERVICE_UNAVAILABLE = 503;
export const GATEWAY_TIMEOUT = 504;
